import React, { memo, useMemo } from 'react';

import PropTypes from 'prop-types';

const LoanActionRows = ({
  items,
  options,
  rootPath,
  optionValueGetter,
  component: Component,
  isDisabled,
  isEditAllowed,
  label,
  itemType,
  isAutomatedActions = false,
  allowEmpty = false,
  ...props
}) => {
  const unusedOptions = useMemo(() => {
    const usedMap = items?.reduce((acc, optionItem) => {
      const value = optionValueGetter(optionItem);

      if (value) {
        acc[value] = true;
      }

      return acc;
    }, {});

    return options.filter(({ value }) => !usedMap[value]);
  }, [items, optionValueGetter, options]);

  return (
    <>
      {items.map((item, index) => (
        <Component
          {...props}
          index={index}
          initOptions={options}
          isAutomatedActions={isAutomatedActions}
          isDisabled={isDisabled}
          isEditAllowed={isEditAllowed}
          isSingleItem={!allowEmpty && items.length === 1}
          itemType={itemType}
          key={index}
          label={label}
          options={unusedOptions}
          rootPath={rootPath}
        />
      ))}
    </>
  );
};

LoanActionRows.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  isEditAllowed: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
  options: PropTypes.array.isRequired,
  component: PropTypes.elementType.isRequired,
  rootPath: PropTypes.string.isRequired,
  optionValueGetter: PropTypes.func.isRequired,
  label: PropTypes.string,
  itemType: PropTypes.string,
  isAutomatedActions: PropTypes.bool,
  allowEmpty: PropTypes.bool,
};

export default memo(LoanActionRows);
